import { render, staticRenderFns } from "./VuelidateForm.vue?vue&type=template&id=73f4d7f4"
import script from "./VuelidateForm.vue?vue&type=script&lang=js"
export * from "./VuelidateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f4d7f4')) {
      api.createRecord('73f4d7f4', component.options)
    } else {
      api.reload('73f4d7f4', component.options)
    }
    module.hot.accept("./VuelidateForm.vue?vue&type=template&id=73f4d7f4", function () {
      api.rerender('73f4d7f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/VuelidateForm.vue"
export default component.exports